import { useHttpClient } from './httpClient';

const resource = 'sessions';
export function createSession({ session }) {
	return useHttpClient().post(`/${resource}`, { session });
}

export function checkSession() {
	return useHttpClient().get(`/${resource}/check`);
}
